import PropTypes from 'prop-types';
import Heading from '../Heading/Heading';
import Wrapper from '../common/Wrapper/Wrapper';
import { Icon } from '../common/Icons';
import {
  StyledSection,
  StyledHeadingWrap,
  StyledCategoryHeading,
  StyledCircle,
  StyledCategoryName,
  StyledList,
  StyledListItem,
  StyledLink,
  StyledLinkContent,
  StyledAppIcon,
  StyledAppName,
  StyledLinkTitle,
  StyledSponsorCont,
  StyledSponsorImg,
  StyledSponsorLinks,
  StyledSponsorLink,
} from './ShraredApps.styles';

function SharedApps({ data }) {
  if (!Object.entries(data).length) return null;

  return (
    <StyledSection>
      <Wrapper>
        <StyledHeadingWrap>
          {data.header ? (
            <Heading
              title={data.header.title && data.header.title}
              styling="font-14-semi-bold"
              icon={
                data.header.icon === 'jaaq' ? (
                  <Icon.Jaaq aria-hidden />
                ) : data.header.icon === 'box' ? (
                  <Icon.Box aria-hidden />
                ) : null
              }
            />
          ) : null}
          {data.category && (
            <StyledCategoryHeading>
              {data.category.color && <StyledCircle color={data.category.color} />}
              {data.category.name && <StyledCategoryName>{data.category.name}</StyledCategoryName>}
            </StyledCategoryHeading>
          )}
          {data.sponsor && (
            <StyledSponsorCont>
              {data.sponsor.imageUrl && <StyledSponsorImg src={data.sponsor.imageUrl} />}
              <StyledSponsorLinks>
                {data.sponsor.site && (
                  <StyledSponsorLink href={data.sponsor.site.url ? data.sponsor.site.url : '/'}>
                    <Icon.Web aria-hidden />
                    {data.sponsor.site.title && (
                      <StyledLinkTitle>{data.sponsor.site.title}</StyledLinkTitle>
                    )}
                  </StyledSponsorLink>
                )}
                {data.sponsor.phone && (
                  <StyledSponsorLink
                    href={data.sponsor.phone.number ? `tel:${data.sponsor.phone.number}` : '/'}
                  >
                    <Icon.Phone aria-hidden />
                    {data.sponsor.phone.title && (
                      <StyledLinkTitle>{data.sponsor.phone.title}</StyledLinkTitle>
                    )}
                  </StyledSponsorLink>
                )}
              </StyledSponsorLinks>
            </StyledSponsorCont>
          )}
        </StyledHeadingWrap>
        {data.list && (
          <StyledList>
            {data.list.map(item => (
              <StyledListItem key={item.id}>
                <StyledLink href={item.link} target="_blank" rel="external noreferrer">
                  <StyledLinkContent>
                    {item.image && <StyledAppIcon src={item.image.icon} alt={item.image.alt} />}
                    {item.name && <StyledAppName>{item.name}</StyledAppName>}
                  </StyledLinkContent>
                  <StyledLinkContent>
                    {item.linkTitle && <StyledLinkTitle>{item.linkTitle}</StyledLinkTitle>}
                    <Icon.Arrow aria-hidden />
                  </StyledLinkContent>
                </StyledLink>
              </StyledListItem>
            ))}
          </StyledList>
        )}
      </Wrapper>
    </StyledSection>
  );
}

SharedApps.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string,
    }),
    category: PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
    }),
    sponsor: PropTypes.shape({
      imageUrl: PropTypes.string,
      site: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
      }),
      phone: PropTypes.shape({
        number: PropTypes.string,
        title: PropTypes.string,
      }),
    }),
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        link: PropTypes.string.isRequired,
        image: PropTypes.shape({
          icon: PropTypes.string,
          alt: PropTypes.string.isRequired,
        }),
        name: PropTypes.string,
        linkTitle: PropTypes.string,
      })
    ),
  }),
};

SharedApps.defaultProps = {
  data: {},
};

export default SharedApps;
